/**
 * quiz C 端 API
 * 契约来源：bmb-global-spec/openspec/specs/saas-org-quiz/api-contract.md
 */
import request from '@/utils/request'

const BASE = '/bmmatch/quizzes'

export function getQuizDetail(quizId, params = {}) {
  return request({
    url: `${BASE}/${quizId}`,
    method: 'get',
    params
  })
}

export function getCurrentCompletionRecord(quizId, params = {}) {
  return request({
    url: `${BASE}/${quizId}/completion-record`,
    method: 'get',
    params
  })
}

export function submitQuizCompletion(quizId, payload) {
  return request({
    url: `${BASE}/${quizId}/completion-records`,
    method: 'post',
    data: payload,
    qs: false,
    headers: { 'Content-Type': 'application/json' }
  })
}
